import React from 'react';
//
import { Loader } from 'components';
import { ROUTES } from 'config/constants';
import { primaryPatientPopulationData } from 'config/data-lists/researchSiteOrganizationLists';
import {
  PhoneIcon,
  LocationIcon,
  MailIcon,
  PhotoIcon,
} from 'components/SvgIcons';

import './index.scss';

export const InfoBoxItem = ({ activeLocationData, isInfoProcessed, group }) => {
  const {
    organizationName,
    location = {},
    contractsManager = {},
    primaryPatientPopulation,
    id,
  } = activeLocationData;
  const {
    name,
    locationAddress: { address } = {},
    locationImage = {},
  } = location;
  const { firstName, lastName, phoneNumber, email } = contractsManager;
  const { urls: { small } = {} } = locationImage;

  let primaryPatient;

  if (primaryPatientPopulation) {
    for (let i = 0; i < primaryPatientPopulationData.length; i++) {
      if (primaryPatientPopulationData[i].value === primaryPatientPopulation) {
        primaryPatient = primaryPatientPopulationData[i].title;
      }
    }
  }

  return group === 'InactiveResearchSite' ? (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <div className="infobox-triangle infobox-inactive-triangle" />
      <div className="infobox-wrapper infobox-inactive-wrapper">
        <Loader isShow={isInfoProcessed}>
          <div className="infobox-content-wrapper">
            <a
              href={`${ROUTES.USER_PROFILE}${ROUTES.INACTIVE_RESEARCH_SITE}/${id}/organization`}
              className="infobox-sitename"
            >
              {organizationName && organizationName}
              <div>
                {firstName} {lastName}
              </div>
            </a>
            {address && (
              <div className="infobox-contacts">
                <div width="25px" height="25px">
                  <LocationIcon className="mr-2" />
                </div>
                {address}
              </div>
            )}
          </div>
        </Loader>
      </div>
    </div>
  ) : (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <div className="infobox-triangle" />
      <div className="infobox-wrapper">
        <Loader isShow={isInfoProcessed}>
          <div className="infobox-img-wrapper">
            {Object.keys(locationImage).length > 0 ? (
              <img src={`${small}`} alt="" />
            ) : (
              <PhotoIcon />
            )}
          </div>
          <div className="infobox-content-wrapper">
            <div className="infobox-orgname montserrat semi-bold">
              {organizationName}
            </div>
            <a
              href={`${ROUTES.USER_PROFILE}${ROUTES.RESEARCH_SITES}/${id}/organization`}
              className="infobox-sitename"
            >
              {name && name}
              <div>
                {firstName} {lastName}
              </div>
            </a>
            {address && (
              <div className="infobox-contacts">
                <div width="25px" height="25px">
                  <LocationIcon className="mr-2" />
                </div>
                {address}
              </div>
            )}

            {phoneNumber && (
              <div className="infobox-contacts">
                <PhoneIcon className="fill-gray-icon mr-2" />
                {phoneNumber}
              </div>
            )}

            {email && (
              <div className="infobox-contacts">
                <MailIcon className="fill-gray-icon mr-2" />
                {email}
              </div>
            )}

            {primaryPatientPopulation && (
              <div className="infobox-population">
                <div>Primary patient population</div>
                {primaryPatient}
              </div>
            )}
          </div>
        </Loader>
      </div>
    </div>
  );
};
